import { useEffect, useRef } from 'react';
import './Hero.css';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import ScrollSmoother from 'gsap/ScrollSmoother';
gsap.registerPlugin(ScrollTrigger, ScrollSmoother);

const Hero = () => {
	const main = useRef();

	useEffect(() => {
		const tl = gsap.timeline();
		tl.to('.left-hero-firstname', {
			scrollTrigger: {
				trigger: 'hero-container',
				start: 'top',
				end: `${window.innerHeight}`,
				scrub: true,
				pinnedContainer: '.hero-container',
			},
			x: '-100vh',
			ease: 'power1.out',
		});
		tl.to('.left-hero-lastname', {
			scrollTrigger: {
				trigger: 'hero-container',
				start: 'top',
				end: `${window.innerHeight}`,
				scrub: true,
				pinnedContainer: '.hero-container',
			},
			x: '-50vw',
			ease: 'power1.out',
		});
		tl.to('.hero-separator', {
			scrollTrigger: {
				trigger: 'hero-container',
				start: 'top',
				end: `${window.innerHeight}`,
				scrub: true,
				pinnedContainer: '.hero-container',
			},
			opacity: 0,
			ease: 'power1.out',
		});
		tl.to('.right-hero', {
			scrollTrigger: {
				trigger: 'hero-container',
				start: 'top',
				end: `${window.innerHeight}`,
				scrub: true,
				pinnedContainer: '.hero-container',
			},
			x: '100vh',
			ease: 'power1.out',
		});
	}, []);
	return (
		<>
			<section
				className="hero-wrapper"
				ref={main}
			>
				<div className="hero-container">
					<div className="left-hero">
						<div className="left-hero-firstname">Nicolas</div>
						<div className="left-hero-lastname">Godeau</div>
					</div>
					<div className="hero-separator"></div>
					<div className="right-hero">Web developer</div>
				</div>
			</section>
		</>
	);
};
export default Hero;
